import Link from 'next/link';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import { useRouter } from 'next/router';
import Image from 'global/Image';
import useSearchCompanyModalStore from 'global/Securities/stores/useSearchCompanyModalStore';
import { withMaintenanceGuard } from 'global/Securities/utils/maintenance';
import useSecuritiesButton from 'features/securities/hooks/useSecuritiesButton';
import realTradingMenu, { MenuItem } from './realTadingMenu';
import { Grid, NavigationMobile } from './styled';
import { BuyButton } from './Mobile.styled';
import IconOrderbook from 'assets/customIcon/PopoverNavbarContainer/IconOrderbook';
import IconPortfolio from 'assets/customIcon/PopoverNavbarContainer/IconPortfolio';
import IconOrder from 'assets/customIcon/PopoverNavbarContainer/IconOrder';
import IconHistory from 'assets/customIcon/PopoverNavbarContainer/IconHistory';
import IconDeposit from 'assets/customIcon/PopoverNavbarContainer/IconDeposit';
import IconWitdrawal from 'assets/customIcon/PopoverNavbarContainer/IconWitdrawal';
import IconSecurity from 'assets/customIcon/PopoverNavbarContainer/IconSecurity';
import IconTransferSaham from 'assets/customIcon/PopoverNavbarContainer/IconTransferSaham';
import IconTradingProfile from 'assets/customIcon/PopoverNavbarContainer/IconTradingProfile';
import IconEStatement from 'assets/customIcon/PopoverNavbarContainer/IconEStatement';
import IconLiveSupport from 'assets/customIcon/PopoverNavbarContainer/IconLiveSupport';
import IconTradingLogout from 'assets/customIcon/PopoverNavbarContainer/IconTradingLogout';

const subMenuList = realTradingMenu.map(({ subMenu }) => subMenu).flat();

const Mobile = () => {
  const router = useRouter();
  const openSearchCompanyModal = useSearchCompanyModalStore((s) => s.showModal);
  const { handleLogoutTrading, handleClickSupportButton } =
    useSecuritiesButton();

  const handleBuyClick = () =>
    withMaintenanceGuard(() => {
      openSearchCompanyModal();
    });

  const handleClickMenu = (data: MenuItem) => {
    if (data.label === 'Trading Logout') {
      handleLogoutTrading();
    }

    if (data.label === 'Live Support') {
      handleClickSupportButton();
    }
  };

  const renderIcon = (logo) => {
    switch (logo) {
      case 'icon-menu3_home':
        return '';
      case 'icon-menu3_orderbook':
        return <IconOrderbook />;
      case 'icon-menu3_portfolio':
        return <IconPortfolio />;
      case 'icon-menu3_order':
        return <IconOrder />;
      case 'icon-menu3_history':
        return <IconHistory />;
      case 'icon-menu3_deposit':
        return <IconDeposit />;
      case 'icon-menu3_withdraw':
        return <IconWitdrawal />;
      case 'icon-securities-file':
        return <IconEStatement />;
      case 'icon-briefcase_arrow':
        return <IconTransferSaham />;
      case 'icon-menu3_account':
        return <IconTradingProfile />;
      case 'icon-menu3_password':
        return <IconSecurity />;
      case 'icon-menu3_support':
        return <IconLiveSupport />;
      case 'icon-menu3_logout':
        return <IconTradingLogout />;
    }
  };

  return (
    <>
      {/* @ts-expect-error */}
      <Flex direction="column" p="16px">
        <Flex align="center">
          <IconWrapper size="40px" style={{ marginRight: 4 }}>
            <Image
              src="/img/ssd.svg"
              alt="logo-sekuritas"
              style={{ width: '100%' }}
            />
          </IconWrapper>
          <Text>Trading Area</Text>
        </Flex>
        <BuyButton onClick={handleBuyClick}>BUY</BuyButton>
      </Flex>

      <Grid>
        {subMenuList.map((data) => (
          <>
            {data.label === 'Stream' ? (
              <NavigationMobile
                key={data.label}
                onClick={() => handleClickMenu(data)}
              >
                <div
                  style={{
                    color: data.matcher(router) ? color.primary : color.dimgray,
                  }}
                >
                  {renderIcon(data.iconmoonMobile)}
                </div>
                <Text
                  as="a"
                  size="11px"
                  align="center"
                  color={data.matcher(router) ? color.primary : color.dimgray}
                >
                  {data.label === 'Stream' ? '' : data.label}
                </Text>
              </NavigationMobile>
            ) : (
              <Link
                href={data.label === 'Stream' ? '' : data.link}
                passHref
                key={data.label}
              >
                <NavigationMobile
                  key={data.label}
                  onClick={() => handleClickMenu(data)}
                >
                  <div
                    style={{
                      color: data.matcher(router)
                        ? color.primary
                        : color.dimgray,
                    }}
                  >
                    {renderIcon(data.iconmoonMobile)}
                  </div>
                  <Text
                    as="a"
                    size="11px"
                    align="center"
                    color={data.matcher(router) ? color.primary : color.dimgray}
                  >
                    {data.label === 'Stream' ? '' : data.label}
                  </Text>
                </NavigationMobile>
              </Link>
            )}
          </>
        ))}
      </Grid>
    </>
  );
};

export default Mobile;
